export const buildUrl = (
  baseUrl: string,
  params: Record<string, string | undefined>,
) => {
  const urlParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value) urlParams.append(key, value)
  })

  const queryString = urlParams.toString()
  return `http://${baseUrl}/${queryString ? '?' + queryString : ''}`
}
